import React from "react";
import { Linkedin, Facebook } from "lucide-react";
import { SOCIAL } from "../data/content";

const PLATFORMS = [
  { key: "linkedin", label: "LinkedIn", Icon: Linkedin },
  { key: "facebook", label: "Facebook", Icon: Facebook },
];

/**
 * Social-Media-Buttons (LinkedIn, Facebook).
 * variant="footer" -> hell auf dunklem Hintergrund (Footer)
 * variant="light"  -> dunkel auf hellem Hintergrund (Kontakt-Seite)
 */
export default function SocialLinks({ variant = "light", className = "" }) {
  const isFooter = variant === "footer";
  const base =
    "w-10 h-10 rounded-full flex items-center justify-center transition-colors";
  const styles = isFooter
    ? "border border-white/20 text-blue-100/90 hover:bg-white hover:text-[#0f2747]"
    : "border-2 border-blue-100 text-blue-brand hover:bg-blue-brand hover:text-white";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="social-links">
      {PLATFORMS.map(({ key, label, Icon }) => {
        const url = SOCIAL[key];
        const href = url && url.trim() !== "" ? url : "#";
        return (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`InaTeB · ${label}`}
            title={`InaTeB · ${label}`}
            data-testid={`social-${key}`}
            className={`${base} ${styles}`}
          >
            <Icon size={19} />
          </a>
        );
      })}
    </div>
  );
}
